export const SupportWidgetContainer = ({ children }) => (
  <div className="xxl:h-full border-primary bg-primary hidden h-[min(658px,100vh-224px)] max-h-[658px] min-h-[80px] w-[400px] origin-bottom-right overflow-y-auto border lg:flex lg:flex-col">
    {children}
  </div>
);
